export const shelfLimitedWidthRange = '(min-width: 1024px) and (max-width: 1090px) '

export const stopsLabel = {
  nonStop: 'nonstop',
  oneStop: '1 stop',
  stops: 'stops',
}

export const cabinClassMap = {
  BEC: 'Basic Economy',
  ECO: 'Economy',
  BUS: 'Business',
  FST: 'First',
  PEC: 'Premium Economy',
}

export const ancillaryMap = {
  CARRY_ON: { name: 'CARRY_ON', description: 'Carry-on bag', inclusion: 'INCLUDED' },
  SEATS: { name: 'SEATS', description: 'Advance seat selection', inclusion: 'INCLUDED' },
  CHECKED_BAG: { name: 'CHECKED_BAG', description: 'Checked Bags', inclusion: 'INCLUDED' },
}

export const baseFareCarriers = ['NK', 'F9', 'SY', '9K', '3M']

export const expectedFareBrandShelves = {
  1: {
    UA: 'Basic Economy',
    AA: 'Basic Economy',
    DL: 'Basic Economy',
    AS: 'Saver',
    HA: 'Main Cabin Basic',
    B6: 'Blue Basic',
    NK: 'Basic Fare',
    F9: 'Basic Fare',
    SY: 'Basic Fare',
    '9X': 'Ultra Low',
  },
  2: {
    UA: 'Economy',
    AA: 'Main Cabin',
    DL: 'Main Cabin',
    AS: 'Main',
    HA: 'Main Cabin',
    B6: 'Blue',
    NK: 'not_offered',
    F9: 'not_offered',
    SY: 'not_offered',
    '9X': 'Ultra Flex',
  },
  3: {
    UA: 'third_tier',
    AA: 'third_tier',
    DL: 'third_tier',
    AS: 'third_tier',
    HA: 'third_tier',
    B6: 'third_tier',
    NK: 'not_offered',
    F9: 'not_offered',
    SY: 'not_offered',
    '9X': 'third_tier',
  },
}

// Temporary hard coded brand attributes while there is an issue with TravelPort
export const backupBrandAttributes = {
  1: {
    UA: {
      SEATS: 'NOT_INCLUDED',
      CARRY_ON: 'NOT_INCLUDED',
      CHECKED_BAG: 'CHARGEABLE',
    },
    AA: {
      SEATS: 'NOT_INCLUDED',
      CARRY_ON: 'INCLUDED',
      CHECKED_BAG: 'CHARGEABLE',
    },
    DL: {
      SEATS: 'NOT_INCLUDED',
      CARRY_ON: 'INCLUDED',
      CHECKED_BAG: 'CHARGEABLE',
    },
    AS: {
      SEATS: 'NOT_INCLUDED',
      CARRY_ON: 'INCLUDED',
      CHECKED_BAG: 'CHARGEABLE',
    },
    HA: {
      SEATS: 'NOT_INCLUDED',
      CARRY_ON: 'INCLUDED',
      CHECKED_BAG: 'CHARGEABLE',
    },
    B6: {
      SEATS: 'NOT_INCLUDED',
      CARRY_ON: 'INCLUDED',
      CHECKED_BAG: 'CHARGEABLE',
    },
    NK: {
      SEATS: 'CHARGEABLE',
      CARRY_ON: 'CHARGEABLE',
      CHECKED_BAG: 'CHARGEABLE',
    },
    F9: {
      SEATS: 'CHARGEABLE',
      CARRY_ON: 'CHARGEABLE',
      CHECKED_BAG: 'CHARGEABLE',
    },
    SY: {
      SEATS: 'CHARGEABLE',
      CARRY_ON: 'CHARGEABLE',
      CHECKED_BAG: 'CHARGEABLE',
    },
    '9X': {
      SEATS: 'NOT_INCLUDED',
      CARRY_ON: 'INCLUDED',
      CHECKED_BAG: 'NOT_INCLUDED',
    },
  },
  2: {
    UA: { SEATS: 'INCLUDED', CARRY_ON: 'INCLUDED', CHECKED_BAG: 'CHARGEABLE' },
    AA: { SEATS: 'INCLUDED', CARRY_ON: 'INCLUDED', CHECKED_BAG: 'CHARGEABLE' },
    DL: { SEATS: 'INCLUDED', CARRY_ON: 'INCLUDED', CHECKED_BAG: 'CHARGEABLE' },
    AS: { SEATS: 'INCLUDED', CARRY_ON: 'INCLUDED', CHECKED_BAG: 'CHARGEABLE' },
    HA: { SEATS: 'INCLUDED', CARRY_ON: 'INCLUDED', CHECKED_BAG: 'CHARGEABLE' },
    B6: { SEATS: 'INCLUDED', CARRY_ON: 'INCLUDED', CHECKED_BAG: 'CHARGEABLE' },
    '9X': {
      SEATS: 'NOT_INCLUDED',
      CARRY_ON: 'INCLUDED',
      CHECKED_BAG: 'INCLUDED',
    },
  },
  3: {
    UA: { SEATS: 'INCLUDED', CARRY_ON: 'INCLUDED', CHECKED_BAG: 'CHARGEABLE' },
    AA: { SEATS: 'INCLUDED', CARRY_ON: 'INCLUDED', CHECKED_BAG: 'CHARGEABLE' },
    DL: { SEATS: 'INCLUDED', CARRY_ON: 'INCLUDED', CHECKED_BAG: 'CHARGEABLE' },
    AS: { SEATS: 'INCLUDED', CARRY_ON: 'INCLUDED', CHECKED_BAG: 'CHARGEABLE' },
    HA: { SEATS: 'INCLUDED', CARRY_ON: 'INCLUDED', CHECKED_BAG: 'CHARGEABLE' },
    B6: { SEATS: 'INCLUDED', CARRY_ON: 'INCLUDED', CHECKED_BAG: 'CHARGEABLE' },
    '9X': {
      SEATS: 'NOT_INCLUDED',
      CARRY_ON: 'INCLUDED',
      CHECKED_BAG: 'INCLUDED',
    },
  },
}

export const fareBrandStatusNames = {
  notOffered: 'not_offered',
  soldOut: 'sold_out',
  available: 'available',
}

export const thirdTierKey = 'third_tier'

export const affirmBaseFare = 199
export const affirmBaseFareExp = 49

export const silverAirlinesAncillaries = {
  name: 'Basic Fare',
  airlineCode: '3M',
  brandAttributes: [
    {
      type: 'CHECKED_BAG',
      description: 'Checked bags',
      inclusion: 'CHARGEABLE',
    },
    {
      type: 'CARRY_ON',
      description: 'Carry-on',
      inclusion: 'INCLUDED',
    },
    {
      type: 'SEATS',
      description: 'Seat Choice',
      inclusion: 'NOT_INCLUDED',
    },
  ],
}

export const maxInitialItins = 3
